/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiKeyRenewalResponse } from '../../models/api-key-renewal-response';

export interface RenewApiKey$Params {
}

export function renewApiKey(http: HttpClient, rootUrl: string, params?: RenewApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiKeyRenewalResponse>> {
  const rb = new RequestBuilder(rootUrl, renewApiKey.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiKeyRenewalResponse>;
    })
  );
}

renewApiKey.PATH = '/api-keys-storage/renew';
